export function Corpo(props){
    return <>{props.children}</>
}